<div class="flex flex-column gap-2">
  @for (rule of rules(); track rule.label) {
    <div class="flex align-items-center gap-2">
      <app-check-circle-filled [fill]="rule.met ? '#17B26A' : '#E1E2E6'"></app-check-circle-filled>
      <div class="text-sm-regular" [class.text-gray-700]="rule.met" [class.text-gray-600]="!rule.met">
        {{ rule.label }}
      </div>
    </div>
  }
</div>
